export const useCategoryStore = defineStore('category', () => {
  const { $axios } = useNuxtApp()
  const progressbarStore = useProgressbarStore()
  const { showSnackbar } = useSnackbarStore()

  const isLoading = ref(false)
  const categoryData = ref(null)
  const catalogData = ref(null)

  const initCategory = () => {
    isLoading.value = false
    categoryData.value = null
    catalogData.value = null
  }
  const getActiveCategory = async (withLoading = true) => {
    progressbarStore.showLoading()
    if (withLoading) isLoading.value = true
    try {
      const response = await $axios.get(useApi().catalogApi.CATALOG_CATEGORYLIST)
      if (response.header.isSuccessful) {
        categoryData.value = response.data
      }
    } catch (e) {
      showSnackbar(e)
    }
    if (withLoading) isLoading.value = false
    setTimeout(() => {
      progressbarStore.hideLoading()
    }, 100)
  }
  const getShowCatalog = async (withLoading = true) => {
    progressbarStore.showLoading()
    if (withLoading) isLoading.value = true
    try {
      const response = await $axios.get(useApi().catalogApi.CATALOG_CATALOGLIST)
      if (response.header.isSuccessful) {
        catalogData.value = response.data
      }
    } catch (e) {
      showSnackbar(e)
    }
    if (withLoading) isLoading.value = false
    setTimeout(() => {
      progressbarStore.hideLoading()
    }, 100)
  }
  return {
    //initCategory,
    getActiveCategory,
    getShowCatalog,
    isLoading,
    categoryData,
    catalogData
  }
})
